export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_12.703620a3.jpg";